module.exports = __webpack_public_path__ + "assets/img/0b1428191bc755c2e9b0eadc11072822.png";